import React from 'react';
import useCollectionState from 'Hooks/useCollectionState';
import fr from 'facet-rest';
import DataContainer from 'Components/UI/DataContainer';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { metaOverrideSet } from './metaOverrideSet';
import { LearnMoreLayout } from './LearnMoreLayout';

export const SHOW_TAX_LEARN_MORE_QUERY_PARAM = 'showTaxLearnMore';

export const LearnMore = ({ resource }) => {
  const { isInitializing, loadingError, collection } = useCollectionState({ relationship: resource.relationship(fr.relationships.learnMore.name) });

  return (
    <DataContainer
      component={MetaResourceRenderer}
      componentProps={{
        layout: LearnMoreLayout,
        metaOverrideSet,
        resource: collection?.resources()?.head(),
      }}
      loading={isInitializing}
      loadingError={loadingError}
    />
  );
};
